import ccrpcWebmapglGlobalScript from '/var/home/fj44404@co.champaign.il.us/.local/code/tip/node_modules/@ccrpc/webmapgl/dist/collection/global/webmapgl.js';
import ionicCoreGlobalScript from '/var/home/fj44404@co.champaign.il.us/.local/code/tip/node_modules/@ionic/core/dist/collection/global/ionic-global.js';
import tipGlobalScript from '/var/home/fj44404@co.champaign.il.us/.local/code/tip/src/global/tip.ts';
export const globalScripts = () => {
  tipGlobalScript();
  ionicCoreGlobalScript();
  ccrpcWebmapglGlobalScript();
};
